<template>
  <div class="case-detail">
    <el-card class="box-card pad">
      <span class="clearfix-sapn">基本资料</span>
      <div class="p_bd">
        <div class="info-box">
          <div class="column">
            <span class="item">
              <span class="title">姓名：</span>
              <span class="txt">{{userInfo.patient.patientName }}</span>
            </span>
            <span class="item">
              <span class="title">年龄：</span>
              <span class="txt">{{userInfo.patient.patientAge }}</span>
            </span>
            <span class="item">
              <span class="title">性别：</span>
              <span class="txt">{{
                PATIENT_GENDER[userInfo.patient.patientGender]
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <span class="clearfix-sapn">主诉</span>
      <div class="p_bd">
        {{ userInfo.cases.described || "无" }}
      </div>
      <span class="clearfix-sapn">现病史</span>
      <div class="p_bd">
        {{ userInfo.cases.hip || "无" }}
      </div>
      <span class="clearfix-sapn">既往史</span>
      <div class="p_bd">
        {{ userInfo.cases.patientHistory || "无" }}
      </div>
      <span class="clearfix-sapn">个人史</span>
      <div class="p_bd">
        {{ userInfo.cases.personalHistory || "无" }}
      </div>
      <span class="clearfix-sapn">家族史</span>
      <div class="p_bd">
        {{ userInfo.cases.familyHistory || "无" }}
      </div>
      <span class="clearfix-sapn">过敏史</span>
      <div class="p_bd">
        {{ userInfo.cases.allergyHistory || "无" }}
      </div>
      <span class="clearfix-sapn">用药史</span>
      <div class="p_bd">
        {{ userInfo.cases.drugHistory || "无" }}
      </div>
      <span class="clearfix-sapn">手术史</span>
      <div class="p_bd">
        {{ userInfo.cases.operationHistory || "无" }}
      </div>
      <span class="clearfix-sapn">其他</span>
      <div class="p_bd">{{ userInfo.cases.other || "无" }}</div>
      <span class="clearfix-sapn">病史小结</span>
      <div class="p_bd">
        {{ userInfo.cases.patientRes || "无" }}
      </div>
      <span class="clearfix-sapn">诊断结果</span>
      <div class="p_bd">
        {{ userInfo.cases.treatmentResName || "无" }}
      </div>
      <span class="clearfix-sapn">附件</span>
      <div class="img-list" v-if="imgList.length">
        <div
          v-for="(item, index) in imgList"
          :key="index"
        >
          <el-image class="image" :src="item" :preview-src-list="imgList">
          </el-image>
        </div>
      </div>
      <div v-else class="p_bd">
        {{ "无" }}
      </div>
    </el-card>
  </div>
</template>

<script>
import config from "@/config/config.js";
import { PATIENT_GENDER } from "@/utils/constants.js";

export default {
  components: {},
  props: {
    userInfo: {
      type: Object,
      default: {},
    },
    imgList: {
      type: Array,
    },
  },
  data() {
    return {
      ImageUrl: config.ImageUrl,
      PATIENT_GENDER,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
/deep/ .el-card__body {
  margin: 20px 0 0 10px !important;
}

.case-detail {
  // padding-top: 20upx;
  // min-height: 700px;
  .el-card__body {
    padding: 20px;
  }

  .box-card {
    min-height: 190px;
  }
  .pad {
    margin-top: 20px;
  }
  .attachment {
    width: 100%;
  }
  .p_bd {
    line-height: 25px;
    color: #101010;
    margin: 30px 0;
    .el-input {
      margin: 8px 0;
    }
    .el-button {
      margin-top: 8px;
    }
    .title {
      margin-right: 10px;
    }
    .info-box {
      .column {
        .item {
          width: 20%;
          display: inline-block;
        }
      }
      .el-collapse {
        margin-top: 20px;
      }
    }
  }
  .image {
    margin-top: 20px;
    width: 150px;
    height: 150px;
    margin-left: 30px;
    margin-bottom: 20px;
  }
  .clearfix-sapn {
    border-left: 5px solid #fc701a;
    padding-left: 5px;
    // color: #8e99ca;
  }
}
</style>
